import { Box, Modal, Fade, Backdrop } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  header?: any;
  body: any;
  open: boolean;
  onClose: () => void;
  maxWidth?: string;
  showCloseIcon?: boolean;
  /** Space between the header row and the body. Defaults to 20px. */
  gap?: string;
}

const CustomModal = (props: Props) => {
  const showCloseIcon = props.showCloseIcon ?? true;

  const handleClose = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    props.onClose();
  };

  return (
    <Modal
      open={props.open}
      onClose={handleClose}
      disableEscapeKeyDown
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 300,
        },
      }}
    >
      <Fade in={props.open} timeout={300}>
        <Box
          position={"absolute"}
          top={"50%"}
          left={"50%"}
          borderRadius={"8px"}
          p={"40px"}
          sx={{
            transform: "translate(-50%, -50%)",
            background: "white",
            outline: "none",
            boxShadow: 24, // ✅ เพิ่มเงาให้ Modal ดูลอยขึ้นมา สวยขึ้น
          }}
          width="80dvw"
          maxWidth={props.maxWidth ?? "auto"}
        >
          <Box
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            gap={props.gap ?? "20px"}
          >
            <Box display={"flex"} flexDirection={"row"} gap={2}>
              <Box
                flex={1}
                sx={{
                  color: "var(--dark)",
                }}
              >
                {props.header}
              </Box>

              {showCloseIcon && (
                <Box
                  onClick={props.onClose}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    color: "text.secondary", // ✅ ปรับสีปุ่มปิดให้นุ่มลง
                    "&:hover": { color: "error.main" }, // ✅ ให้มีลูกเล่นสีแดงตอน hover
                    transition: "color 0.2s",
                  }}
                >
                  <CloseIcon />
                </Box>
              )}
            </Box>

            <Box maxHeight={"70dvh"} flex={1} overflow={"auto"}>
              {props.body}
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
